import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 to-indigo-200">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-indigo-800 mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-indigo-700 mb-4">Page Not Found</h2>
        <p className="text-xl text-gray-600 mb-8">Oops! The Pokémon you're looking for seems to have escaped.</p>
        <Link to="/" className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition duration-300">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;